import { useState, useEffect, useRef } from 'react';

/**
 * Returns elapsed seconds since `startTime`, updating every second.
 * Uses a ref to avoid synchronous setState inside effects (React Compiler rule).
 */
export function useTimerTick(startTime: string | null | undefined): number {
  const [elapsed, setElapsed] = useState(0);
  const startMsRef = useRef<number | null>(null);

  // Sync ref when startTime changes — ref mutation is allowed in effects
  useEffect(() => {
    startMsRef.current = startTime ? new Date(startTime).getTime() : null;
  }, [startTime]);

  // Persistent interval — reads from ref to compute elapsed asynchronously
  useEffect(() => {
    const interval = setInterval(() => {
      const ms = startMsRef.current;
      setElapsed(ms !== null ? Math.max(0, Math.floor((Date.now() - ms) / 1000)) : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return elapsed;
}
